"use client";

import { useEffect } from "react";
import Link from "next/link";
import * as Sentry from "@sentry/nextjs";

import { ErrorScreen } from "@/components/error-screen";

export default function ErrorPage({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <ErrorScreen
      code="SYSTEM FAULT // RECOVERY"
      title="Something slipped its lead."
      description="The page hit an unexpected problem. Try it once more, or head back to familiar ground."
      icon="fa-bolt"
      note={error.digest ? `INCIDENT TAG: ${error.digest}` : undefined}
    >
      <button type="button" onClick={retry} className="paw-btn">
        TRY AGAIN
      </button>
      <Link href="/" className="paw-btn-ghost text-center">
        RETURN HOME
      </Link>
    </ErrorScreen>
  );
}
